const serviceCharges = [0, 348, 580, 1000];

export function formatJrFare(amount) {
    return Number.isFinite(amount) ? amount.toFixed(0) : 'Price unavailable';
}

export function parseJrPricing(optionText) {
    const text = String(optionText || '')
        // Sabre screen responses may contain bell and ANSI control bytes.
        // eslint-disable-next-line no-control-regex
        .replace(/\u0007/g, '')
        // eslint-disable-next-line no-control-regex
        .replace(/\u001b\[[0-?]*[ -/]*[@-~]/g, '')
        .replace(/\u009b[0-?]*[ -/]*[@-~]/g, '');
    const unavailable = { has_pricing: false, pax_prices: [] };
    serviceCharges.forEach(charge => { unavailable[`total${charge}`] = null; });
    // Sabre's fixed-width screen can omit the separator before six-digit fares.
    // Keep the three-character passenger type separate from the adjacent price.
    const regex = /^\s*(?:(?:BR)?\d+(?:-\d+)?\s+)?(\d+)([A-Z]{3}|[A-Z]\d{2})\s*(\d+(?:\.\d{1,2})?)\s+(\d+(?:\.\d{1,2})?)\s*$/gm;
    const paxPrices = [];
    const totals = Object.fromEntries(serviceCharges.map(charge => [`total${charge}`, 0]));
    let match;
    while ((match = regex.exec(text)) !== null) {
        const count = Number(match[1]);
        const unitCents = Math.round(Number(match[3]) * 100);
        const rowCents = Math.round(Number(match[4]) * 100);
        if (!Number.isSafeInteger(count) || count < 1 || !Number.isSafeInteger(unitCents)
            || !Number.isSafeInteger(rowCents) || count * unitCents !== rowCents) {
            return unavailable;
        }
        const price = { numberOfPax: count, passengerType: match[2] };
        serviceCharges.forEach(charge => {
            price[`unitPrice${charge}`] = (unitCents + charge * 100) / 100;
            totals[`total${charge}`] += (unitCents + charge * 100) * count;
        });
        paxPrices.push(price);
    }
    if (!paxPrices.length) return unavailable;
    const declaredTotals = [...text.matchAll(/TOTAL FARE[^\n]*?-\s*[A-Z]{3}\s+(\d+(?:\.\d{1,2})?)/g)];
    if (declaredTotals.length !== 1 || Math.round(Number(declaredTotals[0][1]) * 100) !== totals.total0
        || !Object.values(totals).every(Number.isSafeInteger)) {
        return unavailable;
    }
    serviceCharges.forEach(charge => { totals[`total${charge}`] /= 100; });
    return { has_pricing: true, pax_prices: paxPrices, ...totals };
}
